import { render, staticRenderFns } from "./skuImageSetModal.vue?vue&type=template&id=584da9da&scoped=true&"
import script from "./skuImageSetModal.vue?vue&type=script&lang=js&"
export * from "./skuImageSetModal.vue?vue&type=script&lang=js&"
import style0 from "./skuImageSetModal.vue?vue&type=style&index=0&id=584da9da&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584da9da",
  null
  
)

export default component.exports